import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ValidationIndustryStatus } from 'commons/enums';
import {
  configurationService,
  GetIdValidationResponse,
} from 'commons/services';
import { useCountry } from './useCountry';

export const useIdentityValidation = (
  options?: Omit<
    UseQueryOptions<GetIdValidationResponse>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { isMexico } = useCountry();

  const idValidationQuery = useQuery<GetIdValidationResponse>(
    ['identityValidation'],
    () => configurationService.getIdValidation(),
    {
      ...options,
      enabled: !isMexico && (options?.enabled ?? true),
    },
  );

  const statusDeniedAndInvalidIndustry =
    idValidationQuery.data?.status === 'denied' &&
    (idValidationQuery.data?.statusDetail ===
      ValidationIndustryStatus.RESTRICTED ||
      idValidationQuery.data?.statusDetail ===
        ValidationIndustryStatus.PROHIBITED);

  return {
    ...idValidationQuery,
    isLoading: isMexico ? false : idValidationQuery.isLoading,
    statusDeniedAndInvalidIndustry,
  };
};
